<template>
  <div>
    <MtxLoading v-if="isLoading" />

    <ul v-else-if="comments.length" class="list-plain">
      <li v-for="comment in comments" :key="comment.id">
        <article class="grid column-gap grid-3-columns@sm grid-4-columns@md mb-4">
          <header class="mb-1">
            <ProfileLink :address="comment.author" />
          </header>

          <div class="column-span-2@sm column-span-3@md">
            <p class="comment__content mb-0">{{ comment.content }}</p>
            <small class="color-muted">
              <time :datetime="comment.updatedAt">
                {{ comment.updatedAt | distanceInWordsToNow }}
              </time>
            </small>
          </div>
        </article>
      </li>
    </ul>

    <p v-if="disableComments">Comments have been disabled.</p>

    <CommentsForm
      v-else
      :referenceType="referenceType"
      :referenceId="referenceId"
      @success="comments.push($event)"
    />
  </div>
</template>

<script>
import CommentsForm from "@/components/comments/CommentsForm"
import API from "@/api"

export default {
  components: {
    CommentsForm
  },

  props: {
    referenceType: {
      type: String,
      required: true
    },
    referenceId: {
      type: Number,
      required: true
    },
    disableComments: Boolean
  },

  data: () => ({
    isLoading: false,
    comments: []
  }),

  async mounted() {
    this.isLoading = true

    const { success, data } = await API.getComments({
      referenceType: this.referenceType,
      referenceId: this.referenceId
    })

    if (success) {
      this.comments = data.comments
    }

    this.isLoading = false
  }
}
</script>

<style lang="scss">
.comment__content {
  word-break: break-word;
}
</style>
